export default __webpack_public_path__ + "static/Deeper-dive-marlene-mcneese-profile-9ecc14b5b60b783dc5d4930a09db1011.png";